import { Inject, Injectable } from "@angular/core";
import { AbstractService } from "./abstract-service.service";
import { CartProduct } from "../Models/cart-product";
import { HttpClient } from "@angular/common/http";
import { APP_CONFIG, AppConfig } from "./config";
import { Observable } from "rxjs";
import { Response } from "../Models/response";

@Injectable({
  providedIn: "root",
})
export class CartProductService extends AbstractService<CartProduct, number> {
  url: string;

  constructor(
    protected http: HttpClient,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    super(http);
    this.url = `${this.appConfig.apiEndpoint}/new/carts`;
  }

  public getCurrentClient(): Observable<CartProduct[]> {
    const url = `${this.url}/guichet/current-client`;
    return this.http.get<CartProduct[]>(url, {
      withCredentials: true,
    });
  }

  public emptyCart(): Observable<void> {
    const url = `${this.url}/all`;
    return this.http.delete<void>(url, {
      withCredentials: true,
    });
  }

  override add(entity: CartProduct): Observable<{ id: number }> {
    const payload = {
      cartId: entity.cartId,
      configurationId: entity.configurationId,
      quantity: entity.quantity,
    };
    return this.http.post<{ id: number }>(this.url, payload, {
      withCredentials: true,
    });
  }
}
